module.exports = "<section class=\"lg-info\">\r\n    <section>\r\n      <app-distributor-info [distributor]=\"distributor\" [showUpdateButton]=\"false\"></app-distributor-info>\r\n    </section>\r\n  \r\n    <section>\r\n      <app-dealer-info\r\n        [dealer]=\"dealer\"\r\n      ></app-dealer-info>\r\n    </section>\r\n  \r\n    <section>\r\n      <app-training [training]=\"training\"></app-training>\r\n    </section>\r\n  </section>\r\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/distributor/containers/dealer-view/dealer-view.component.html
// module id = ./src/app/distributor/containers/dealer-view/dealer-view.component.html
// module chunks = main